'use strict';

/* globals alert */
angular.module('formApp').factory('formHandler', [
  '$resource',
  '$routeParams',
  '$timeout',
  'CONFIG',

  function ($resource, $routeParams, $timeout, CONFIG) {
    var formHandler = {};

    formHandler.saveForm = function ($scope, quitAfterSaving) {
      if (!formHandler.isFormValid($scope)) {
        return false;
      }
      $scope.models.status = 'Formular wird gespeichert...';

      formHandler.cleanupCustomButtons($scope);

      /* callback bekommt parameter x, y */
      $scope.models.form.$update(
        function () {
          $scope.models.status = 'Formular gespeichert.';
          $scope.models.formOriginal = angular.copy($scope.models.form);
          if (quitAfterSaving) {
            document.querySelector('.fd-js-quit').click();
          } else {
            $timeout(function () {
              $scope.models.status = false;
            }, 1000 * 10);
          }
        },
        function (error) {
          $scope.models.status = 'Das Formular konnte nicht gespeichert werden!';

          $timeout(function () {
            $scope.models.status = false;
          }, 1000 * 10);

          if (error && error.data && error.data.message) {
            alert(
              'Beim Speichern des Formulars ist folgender Fehler aufgetreten:' +
                (error && error.data && error.data.message ? '\n\n' + error.data.message : '')
            );
          }
        }
      );
    };

    formHandler.saveFormAndQuit = function ($scope) {
      formHandler.saveForm($scope, true);
    };

    formHandler.resetForm = function ($scope) {
      const emptyForm = {
        id: $scope.makeId(),
        sections: [],
        engineVersion: '1'
      };
      $scope.models.form = angular.copy(emptyForm);
      $scope.models.formOriginal = angular.copy(emptyForm);
    };

    formHandler.loadForm = function ($scope) {
      if ($scope.isWeb) {
        formHandler.resetForm($scope);
        return;
      }

      var resourceUrl = CONFIG.FORM_RESOURCE_URL;
      var resourceParams = {
        formId: $routeParams.formId,
        timestamp: Date.now()
      };

      if ($scope.isLocal) {
        resourceUrl = CONFIG.LOCAL_FORM_RESOURCE_URL.replace('{port}', $routeParams.nodeId);
      }

      var FormService = $resource(resourceUrl, resourceParams, {
        update: {
          method: 'PUT'
        }
      });

      $scope.formService = FormService.get();

      $scope.models.status = 'Das Formular wird geladen...';
      $scope.formService.$promise.then(
        function (result) {
          if (!result.engineVersion) {
            result.engineVersion = '1';
          }
          $scope.models.form = angular.copy(result);
          $scope.models.formOriginal = angular.copy(result);
          $scope.models.status = false;
        },
        function () {
          $scope.models.status = 'Das Formular konnte nicht geladen werden.';
        }
      );
    };

    formHandler.traverseFormJson = function ($scope) {
      // empty the collections
      $scope.fieldgroupsColl = [];
      $scope.duplicateId = null;
      $scope.duplicateType = null;

      angular.forEach($scope.models.form.sections, function (section) {
        angular.forEach(section.fieldGroups, function (fieldGroup) {
          $scope.fieldgroupsColl.push(fieldGroup);
        });
      });
    };

    formHandler.noDuplicates = function (obj, $scope) {
      var idCollection = [];
      for (var i = 0; i < obj.length; i++) {
        if (idCollection.length > 0 && idCollection.indexOf(obj[i].id) !== -1) {
          $scope.duplicateId = obj[i].id;
          $scope.duplicateType = obj[i].type ? 'field' : 'fieldgroup';
          return false;
        }
        idCollection.push(obj[i].id);
      }
      return true;
    };

    formHandler.checkIds = function ($scope) {
      // fill the collections
      formHandler.traverseFormJson($scope);

      // check duplicates in fieldgroups
      if (formHandler.noDuplicates($scope.fieldgroupsColl, $scope)) {
        // collect fields
        angular.forEach($scope.fieldgroupsColl, function (fieldgroup) {
          var fieldColl = [];

          angular.forEach(fieldgroup.rows, function (row) {
            // check duplicates in fields
            fieldColl = fieldColl.concat(row.fields);
          });
          formHandler.noDuplicates(fieldColl, $scope);
          return !$scope.duplicateId;
        });
        if ($scope.duplicateId) {
          return 'Mehrfach vorhandene Feld-Id: ' + $scope.duplicateId;
        }
      } else {
        return 'Mehrfach vorhandene Feldgruppen-Id: ' + $scope.duplicateId;
      }
    };

    formHandler.initializeCustomButtons = function ($scope) {
      $scope.models.form.customButtons = $scope.models.form.customButtons || {
        buttons: []
      };
    };

    formHandler.isFormValid = function ($scope) {
      var validationError;

      validationError = validationError || formHandler.checkIds($scope);
      validationError = validationError || formHandler.checkReferences($scope);

      if (validationError !== undefined) {
        alert(validationError);
        return false;
      }
      return true;
    };

    formHandler.checkReferences = function ($scope) {
      // Get all referenced fields.
      var referencedFields = formHandler.getAllReferencedFields($scope);

      var errorMessage;

      // Iterate over references.
      _.some(referencedFields, function (element) {
        var fieldDescription = element.groupId + ':' + element.groupIndex + ':' + element.fieldId;

        // check if field still exists.
        var fieldGroup = formHandler.findFieldGroup($scope.models.form.sections, element.groupId);

        if (!fieldGroup) {
          errorMessage = 'Feld "' + fieldDescription + '": Referenzierte Feldgruppe existiert nicht mehr.';
          return true;
        }

        var field = formHandler.findFieldInFieldgroup(fieldGroup, element.fieldId);

        if (!field) {
          errorMessage = 'Feld "' + fieldDescription + '": Referenziertes Feld existiert nicht mehr.';
          return true;
        }

        // check if group is multiple if necesssary
        if (element.groupIndex !== 0 && !fieldGroup.multiple) {
          errorMessage =
            'Es wurde eine konkrete Instanz der Feldgruppe beim Feld "' +
            fieldDescription +
            '" referenziert, jedoch ist diese Feldgruppe nicht mehrfach ausfüllbar.';
          return true;
        }

        return false;
      });

      return errorMessage;
    };

    formHandler.getAllReferencedFields = function ($scope) {
      var fieldgroups = _.flatten(
        $scope.models.form.sections.map(function (section) {
          return section.fieldGroups || [];
        })
      );
      var rows = _.flatten(
        fieldgroups.map(function (fieldgroup) {
          return fieldgroup.rows || [];
        })
      );
      var fields = _.flatten(
        rows.map(function (row) {
          return row.fields || [];
        })
      );

      var allFields = _.flatten(
        fields.map(function (field) {
          if (field.externalValue && field.externalValue.scope === 'DEFINED') {
            return field.externalValue.fieldIds;
          }
          return [];
        })
      );

      return allFields;
    };

    formHandler.findFieldGroup = function (sections, groupId) {
      var fieldgroups = _.flatten(
        sections.map(function (section) {
          return section.fieldGroups || [];
        })
      );
      var existingFieldgroup = _.find(fieldgroups, function (fieldgroup) {
        return fieldgroup.id === groupId;
      });
      return existingFieldgroup;
    };

    formHandler.findFieldInFieldgroup = function (fieldgroup, fieldId) {
      var fieldsInFieldgroup = _.flatten(
        fieldgroup.rows.map(function (row) {
          return row.fields || [];
        })
      );
      var existingField = _.find(fieldsInFieldgroup, function (f) {
        return f.id === fieldId;
      });
      return existingField;
    };

    formHandler.cleanupCustomButtons = function ($scope) {
      if (!$scope.models.form.customButtons) {
        return false;
      }
      if ($scope.models.form.customButtons.buttons.length === 0) {
        delete $scope.models.form.customButtons;
      }
    };

    return formHandler;
  }
]);
